
  import "bootstrap/js/dist/tab";
  import {Component, Vue} from 'vue-property-decorator';
  import CookieDlg from "@/components/CookieDlg.vue";
  import DownloadGumroad from "@/components/PaidDownloadButtons.vue";
  import Header from "@/components/Header.vue";
  import LandingSection from "@/components/LandingSection.vue";
  import Cookies from "js-cookie";
  import PaidDownloadButtons from "@/components/PaidDownloadButtons.vue";
  import License from "@/components/License.vue";
  import TabSwitcher from "@/components/TabSwitcher";
  import $ from "jquery";
  import {gaSendPageview} from "@/components/Analytics";
  import DownloadTab28 from "@/views/DownloadTab28.vue";
  import DownloadTab30 from "@/views/DownloadTab30.vue";

  @Component({
    components: {
      DownloadTab30,
      DownloadTab28, License, CookieDlg, PaidDownloadButtons, DownloadGumroad, LandingSection, Header}
  })
  export default class DownloadLanding extends Vue {
    private adsSidebar300 = '';
    private adsSidebarTall = '';
    private tabSwitcher = new TabSwitcher();
    private readonly needsCookieConsent = Cookies.get("CookieConsent") !== "true";

    public $refs!: {
      cookieDlg: CookieDlg;
    };

    public mounted() {
      this.adsSidebar300 = document.getElementById('ads-sidebar-300-tmpl')?.innerHTML;
      document.getElementById('ads-sidebar-300-tmpl')?.remove();
      this.adsSidebarTall = document.getElementById('ads-sidebar-tall-tmpl')?.innerHTML;
      document.getElementById('ads-sidebar-tall-tmpl')?.remove();
      Cookies.set("download-visited",'y');
      if (this.needsCookieConsent) {
        this.$refs.cookieDlg.show();
      }
      this.tabSwitcher.init('download30');

      gaSendPageview();
    }

    private isDisplayed(selector: string): boolean {
      return $(selector).css("display") !== "none";
    }
  }
